import { useState } from 'react';
import styled from '@emotion/styled';

// Styled components
const ButtonContainer = styled.button`
    position: relative;
    display: flex;
    flex-direction: ${(props) => (props.expandDirection === 'left' ? 'row-reverse' : 'row')};
    align-items: center;
    overflow: hidden;
    border-radius: 50px;
    border: 1px solid ${(props) => props.borderColor || '#000'};
    background-color: ${(props) => props.backgroundColor || '#fff'};
    color: ${(props) => props.textColor || '#000'};
    padding: 0;
    height: ${(props) => props.size || '48px'};
    width: ${(props) => (props.isHovered ? 'auto' : props.size || '48px')};
    transition: width 1s ease-in-out;
    box-shadow: ${(props) =>
        props.isHovered ? '0px 15px 35px rgba(0, 0, 0, 0.8)' : '0px 12px 25px rgba(0, 0, 0, 0.6)'};
    justify-content: ${(props) => (props.expandDirection === 'left' ? 'flex-start' : 'flex-end')};
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.size || '48px'};
    height: ${(props) => props.size || '48px'};
    flex-shrink: 0;
`;

const TextContainer = styled.div`
    padding: ${(props) => (props.expandDirection === 'left' ? '0 0 0 16px' : '0 16px 0 0')};
    white-space: nowrap;
    opacity: ${(props) => (props.isHovered ? 1 : 0)};
    transform: translateX(${(props) => (props.isHovered ? '0' : props.expandDirection === 'left' ? '10px' : '-10px')});
    transition:
        opacity 0.2s ease-in-out,
        transform 0.2s ease-in-out;
`;
export const ExpandableButton = ({
    icon,
    text,
    backgroundColor,
    textColor,
    borderColor,
    onClick,
    className,
    size,
    expandDirection = 'left',
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <ButtonContainer
            size={size}
            backgroundColor={backgroundColor}
            textColor={textColor}
            borderColor={borderColor}
            className={className}
            isHovered={isHovered}
            expandDirection={expandDirection}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
        >
            <IconContainer size={size}>{icon}</IconContainer>
            <TextContainer isHovered={isHovered} expandDirection={expandDirection}>
                {text}
            </TextContainer>
        </ButtonContainer>
    );
};
const DivContainer = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid ${(props) => props.borderColor || '#000'};
    background-color: ${(props) => props.backgroundColor || '#fff'};
    color: ${(props) => props.textColor || '#000'};
    padding: 0 16px;
    height: ${(props) => props.height || '48px'};
    width: ${(props) => props.width || '500px'};
    padding-right: 25px;
    transition:
        max-width 0.5s ease,
        border-radius 0.3s ease;
    box-shadow: ${(props) =>
        props.isHovered ? '0px 15px 35px rgba(0, 0, 0, 0.8)' : '0px 12px 25px rgba(0, 0, 0, 0.6)'};
    white-space: nowrap;
`;

export const ExpandableDiv = ({
    icon,
    text,
    backgroundColor,
    textColor,
    borderColor,
    onClick,
    className,
    height,
    width,
    children,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <DivContainer
            height={height}
            width={width}
            backgroundColor={backgroundColor}
            textColor={textColor}
            borderColor={borderColor}
            className={className}
            isHovered={isHovered}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
        >
            {children}
        </DivContainer>
    );
};
